module.exports = __webpack_public_path__ + "static/31-0a8a9e76ce29c2701d01679c667f9ea6.png";